import { component } from 'picoapp';
import { debounce } from 'lodash';

export default component(async (node) => {
  const searchToggle = document.querySelector('[data-open="search"]');
  const searchInput:HTMLInputElement = node.querySelector('[data-input]');
  const searchLabel:HTMLInputElement = document.querySelector('[data-search-label]');
  const closeSearchButton = node.querySelector('[data-close]');

  const openSearch = () => {
    searchLabel.hidden = true;
    node.hidden = false;
    searchInput.focus();
    document.dispatchEvent(new Event('search:open'));
  };

  searchInput.addEventListener('keyup', debounce(async () => {
    if (searchInput.value !== '') {
      document.dispatchEvent(new CustomEvent('search:query', { detail: { query: searchInput.value } }));
    }
  }, 300));

  closeSearchButton.addEventListener('click', () => {
    document.dispatchEvent(new Event('search:close'));
  });

  searchToggle.addEventListener('click', () => {
    openSearch();
  });

  document.addEventListener('search:closed', () => {
    searchInput.value = '';
    searchInput.blur();
    searchLabel.hidden = false;
    node.hidden = true;
  });
});
